import React from "react";
import { InformationBox } from "../../InformationBox/InformationBox";
import { LabelDirectionType } from "../../LabelWithInformationBox/LabelWithInformationBox";

import "./PageSidebarHeader.scss";

interface Props {
  title: string;
  message: string;
  onTitleClick?: () => void;
  children?: React.ReactNode;
}

export const PageSidebarHeader = (props: Props) => {
  const { title, message, children, onTitleClick } = props;

  const handleTitleClick = () => {
    if (onTitleClick) {
      onTitleClick();
    }
  };

  return (
    <div className="PageSidebarHeader">
      <h3
        onClick={handleTitleClick}
        className={`${onTitleClick ? "cursor-pointer" : ""}`}
      >
        {title}
      </h3>
      <InformationBox message={message} className="InformationBox__top" />
      {children}
    </div>
  );
};
